import { ColumnTagController } from './column-tag.controller'

function columnTag () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/directives/column-tag/column-tag-directive.html?$$REVISION$$',
    controller: ColumnTagController,
    scope: {
      column: '<',
      actions: '<',
      index: '<'
    }
  }
}

export { columnTag }
